<template>
  <div id="main" class="contact-importer card-style">
    <br />
    <d-button
      class="btn-blue"
      id="launch"
      value="Import your contacts"
      @click.prevent="launch"
      style="color:#232349;font-weight:700;"
    >Import Contacts</d-button>
  </div>
</template>

<script>
import FlatfileImporter from "flatfile-csv-importer";
import config from "../../env.js";
const importer = new FlatfileImporter(config.license, config.config);
export default {
  data() {
    return {
      results: "Your raw output will appear here."
    };
  },
  methods: {
    launch() {
      analytics.track("Clicked Import Contacts");
      importer.setCustomer({ userId: 1, email: "me@david.gs" });
      importer
        .requestDataFromUser()
        .then(results => {
          this.results = JSON.stringify(results.validData, null, 2);
          importer.displaySuccess("Success!");
          this.$store.dispatch("uploadsupporters", results.validData);
        })
        .catch(function(error) {
          console.info(error || "window close");
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.contact-importer {
  height: 600px;
  margin-top: 10%;
  margin-bottom: 10%;
  margin-left: 10%;
  margin-right: 10%;
}
.download {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.download a {
  color: #3c4151;
  text-decoration: none;
}
.download a:hover {
  color: #1d62b4;
}
.contact-importer {
  min-height: 600px;
  display: flex;
  justify-items: center;
  align-items: center;
}
#launch {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin: 96px 0 64px 0;
  border: none;
  border-radius: 4px;
  color: #fff;
  display: block;
  padding: 0 64px;
  height: 44px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 15px;
  font-weight: 500;
  outline: 0;
  background-color: #f2557a;
}
#launch:focus,
#launch:hover {
  background-color: #f2557a;
}
#launch:active {
  background-color: #f2557a;
}
#raw_output {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  padding: 64px;
  margin: 32px 0;
  border: 1px solid #c1c6d1;
  border-radius: 4px;
  font-family: "Courier New", monospace;
  background-color: #3c4151;
  color: #fff;
  height: 200px;
}
</style>
